import {
  GET_SCHOOLS,
  GET_SCHOOLS_SUCCESS,
  GET_SCHOOLS_FAILURE,
  GET_SCHOOL,
  GET_SCHOOL_SUCCESS,
  GET_SCHOOL_FAILURE,
  ADD_SCHOOL,
  ADD_SCHOOL_SUCCESS,
  ADD_SCHOOL_FAILURE,
  EDIT_SCHOOL,
  EDIT_SCHOOL_SUCCESS,
  EDIT_SCHOOL_FAILURE,
  CHANGE_SCHOOL_STATUS,
  CHANGE_SCHOOL_STATUS_SUCCESS,
  CHANGE_SCHOOL_STATUS_FAILURE,
} from "../constants";

export default class SchoolAction {
  static getSchools(payload, cb) {
    return {
      type: GET_SCHOOLS,
      payload,
      cb,
    };
  }
  static getSchoolsSuccess(payload) {
    return {
      type: GET_SCHOOLS_SUCCESS,
      payload,
    };
  }
  static getSchoolsFailure(payload) {
    return {
      type: GET_SCHOOLS_FAILURE,
      payload,
    };
  }
  static getSchool(payload, cb) {
    return {
      type: GET_SCHOOL,
      payload,
      cb,
    };
  }
  static getSchoolSuccess(payload) {
    return {
      type: GET_SCHOOL_SUCCESS,
      payload,
    };
  }
  static getSchoolFailure(payload) {
    return {
      type: GET_SCHOOL_FAILURE,
      payload,
    };
  }
  static addSchool(payload, cb) {
    return {
      type: ADD_SCHOOL,
      payload,
      cb,
    };
  }
  static addSchoolSuccess(payload) {
    return {
      type: ADD_SCHOOL_SUCCESS,
      payload,
    };
  }
  static addSchoolFailure(payload) {
    return {
      type: ADD_SCHOOL_FAILURE,
      payload,
    };
  }
  static editSchool(payload, cb) {
    return {
      type: EDIT_SCHOOL,
      payload,
      cb,
    };
  }
  static editSchoolSuccess(payload) {
    return {
      type: EDIT_SCHOOL_SUCCESS,
      payload,
    };
  }
  static editSchoolFailure(payload) {
    return {
      type: EDIT_SCHOOL_FAILURE,
      payload,
    };
  }
  static changeSchoolStatus(payload, cb) {
    return {
      type: CHANGE_SCHOOL_STATUS,
      payload,
      cb,
    };
  }
  static changeSchoolStatusSuccess(payload) {
    return {
      type: CHANGE_SCHOOL_STATUS_SUCCESS,
      payload,
    };
  }
  static changeSchoolStatusFailure(payload) {
    return {
      type: CHANGE_SCHOOL_STATUS_FAILURE,
      payload,
    };
  }
}
